import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import type { PdpPageProductDataDto } from "~/features/productDetails/dto/PdpPageProductDataDto";

export interface ProductComparisonData {
  showDifference: boolean;
  products: PdpPageProductDataDto[];
  maxSize: number;
  productCodes: string[];
}

export const getComparisonData = async (): Promise<ProductComparisonData> => {
  const url = occUrl("/product-comparison/data");

  const response = await occFetch(url, {
    method: "GET",
    cache: "no-cache",
    headers: {
      accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch comparison data: ${response.status}`);
  }

  const data = (await response.json()) as ProductComparisonData;

  return data;
};
